import { render, staticRenderFns } from "./TrTestSelectGame.vue?vue&type=template&id=307b8fd2&scoped=true&"
import script from "./TrTestSelectGame.vue?vue&type=script&lang=js&"
export * from "./TrTestSelectGame.vue?vue&type=script&lang=js&"
import style0 from "./TrTestSelectGame.vue?vue&type=style&index=0&id=307b8fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307b8fd2",
  null
  
)

export default component.exports